import { render } from "./GameList.vue?vue&type=template&id=7225d93c&scoped=true"
import script from "./GameList.vue?vue&type=script&lang=js"
export * from "./GameList.vue?vue&type=script&lang=js"

import "./GameList.vue?vue&type=style&index=0&id=7225d93c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7225d93c"]])

export default __exports__